module.exports = __webpack_public_path__ + "img/MRBTC.e1994969.png";